<div *ngIf="hasData | async" class="wrapper">
    <canvas baseChart
        [data]="doughnutChartData"
        [chartType]="doughnutChartType"
        [colors]="doughnutChartColors"
        [options]="doughnutChartOptions"
        [plugins]="doughnutChartPlugins">
    </canvas>
</div>
